import { Grid, Stack } from '@mui/material';
import { useState } from 'react';
import { Item, IUserDTO, WsTypography, WsTypoVariants } from 'wisestep-base';

import { useUserContext } from '../../../context';
import ComposableDashboardContextProvider from '../../../features/analyticsPage/context/ComposableDashboardContext';
import ComposableDashboardsCollectionsContextProvider from '../../../features/analyticsPage/context/ComposableDashboardsCollectionContext';
import ComposableDynamicListingContextProvider from '../../../features/analyticsPage/context/ComposableDynamicListingContext';

import HomePageDashBoard from './HomePageDashBoard';
import PhoneNumberPopup from './PhoneNumberPopup';
import WorkspaceExpireMsg from './WorkspaceExpireMsg';

const Home = () => {
  const loggedInUser = useUserContext().userDTO as IUserDTO;
  const [isDashboard, setIsDashboard] = useState(false);
  function DashboardValue(value: any): void {
    setIsDashboard(value);
  }

  return (
    <Stack direction="column" justifyContent="center" spacing={isDashboard ? 1.5 : 3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Item sx={{ pb: 0, mb: 0 }}>
            <WsTypography bold={true} variant={WsTypoVariants.TITLE}>
              {`Hi ${loggedInUser?.firstName ?? ''} 👋`}
            </WsTypography>
          </Item>
        </Grid>
      </Grid>
      <PhoneNumberPopup />
      <WorkspaceExpireMsg />
      <ComposableDynamicListingContextProvider>
        <ComposableDashboardContextProvider>
          <ComposableDashboardsCollectionsContextProvider>
            <HomePageDashBoard isDashboard={DashboardValue} />
          </ComposableDashboardsCollectionsContextProvider>
        </ComposableDashboardContextProvider>
      </ComposableDynamicListingContextProvider>
    </Stack>
  );
};

export default Home;
